<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 15:03:16
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-11-14 14:12:46
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/SetImgMultOrOne.vue
-->
<template>
    <div class="mt-5">
        <div class="grid grid-cols-2 gap-1 sm:gap-2">
            <button
                v-for="item in typeEnums"
                :key="item.value"
                @click="image_type = item.value"
                :class="[
                    'flex h-[36px] border bg-tool-default-black border-transparent cursor-pointer flex-col items-center justify-center gap-[10px] rounded-[10px] text-sm duration-300 p-[10px]',
                    image_type !== item.value
                        ? 'border-white/[.06] hover:border-white/30'
                        : '!border-white/50 !bg-white/10',
                ]"
            >
                <span
                    :class="[
                        'text-xs font-medium transition-colors duration-200',
                        image_type === item.value
                            ? 'text-white'
                            : 'text-not-active',
                    ]"
                >
                    {{ item.name }}
                </span>
            </button>
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from '../../composables/useI18n'

const typeEnums = computed(() => {
    return [
        {
            name: t('tools.frameToVideoTitle'),
            value: 'single_frame',
        },
        {
            name: t('tools.IngredientsToVideo'),
            value: 'multiple_frames',
        },
    ]
})

const { t, locale } = useI18n()

const image_type = defineModel('image_type')
</script>
<style scoped lang="less"></style>
